// extracted by mini-css-extract-plugin
export default {"detailsUpdateForm":"UpdateProjectForm_detailsUpdateForm__0eJET"};